import React from 'react';
// @ts-ignore
import { Card } from '@els/els-react--card';
// @ts-ignore
import { LinkElement } from '@els/els-react--link-element';
import './navigation-card.scss';

export interface NavigationCardProps {
    onClickNavigateTo: () => void;
    href: string;
    title: string;
    description: string;
    cardLogo: string;
    buttonText: string;
    ariaLabel?: string;
    skillEvaluatorClass?: boolean;
}
const NavigationCard = (props: NavigationCardProps) => {
    const {
        onClickNavigateTo,
        href,
        title,
        description,
        cardLogo,
        buttonText,
        ariaLabel,
        skillEvaluatorClass,
    } = props;
    const cardId = title.toLowerCase().replace(/ /g, '-');
    const cardClassName = 'navigation-card';
    const baseClassName = skillEvaluatorClass
        ? `${cardClassName}--skills-evaluator`
        : cardClassName;

    return (
        <Card className={baseClassName}>
            <div className={`${baseClassName}__content`}>
                <div className={`${baseClassName}__text-wrapper`}>
                    <div>
                        <h3 className={`${baseClassName}__text-wrapper-title`}>
                            {title}
                        </h3>
                        <div
                            className={`${baseClassName}__text-wrapper-description`}
                        >
                            <p>{description}</p>
                        </div>
                    </div>
                    <div className={`${baseClassName}__text-wrapper-button`}>
                        <LinkElement
                            href={href}
                            iconSprite="ChevronRight"
                            iconRight
                            iconSize="s"
                            aria-label={ariaLabel}
                            className={`${baseClassName}__text-wrapper-link-button`}
                            onClick={(e: React.MouseEvent) => {
                                e.preventDefault();
                                onClickNavigateTo();
                            }}
                        >
                            {buttonText}
                        </LinkElement>
                    </div>
                </div>
                <div className={`${baseClassName}__icon`}>
                    <img
                        id={`${cardId}-logo`}
                        src={cardLogo}
                        alt=""
                        width={87}
                        height={87}
                    />
                </div>
            </div>
        </Card>
    );
};
NavigationCard.defaultProps = {
    ariaLabel: undefined,
    skillEvaluatorClass: false,
};

export default NavigationCard;
